export default __webpack_public_path__ + "static/media/WD-1508 full metal body touch pos system.208ee53d.jpg";